export default {
  schema: {
    type: "string",
    format: "email",
  },
};
